module.exports = __webpack_public_path__ + "media/images/custom_page/bae173_event2/bae173-event-en-94c9dbbf7e1d0804987ec4f0c01b6c97.png";